<script setup>
/*
  Este componente realmente es un contenedor que escucha el evento
  'existen-notas-bloqueadas' y muestra el modal ModalBloquearEvaluacion
  Hacemos este componente para poder reutilizar el modal que ya existe
  porque el panel de bloqueos todavía no se gestiona desde Vue.

  Ojo que hay que poner el componente dentro del form de los bloqueos
*/
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import ModalBloquearEvaluacion from '@/apps/panel_evaluacion/ModalBloquearEvaluacion.vue';

const mostrarModal = ref(false);
const tipoBloqueo = ref('');

function handleNotasBloqueadas(event) {
  tipoBloqueo.value = '';
  mostrarModal.value = true;
}

onMounted(() => {
  document.addEventListener('existen-notas-bloqueadas', handleNotasBloqueadas);
});

onUnmounted(() => {
  document.removeEventListener('existen-notas-bloqueadas', handleNotasBloqueadas);
});

function bloqueoAceptado(tipoBloqueoSeleccionado) {
  mostrarModal.value = false;
  tipoBloqueo.value = tipoBloqueoSeleccionado;
  // Lo hacemos después para que ya esté puesto el tipo de bloqueo antes del submit
  nextTick(() => {
    // const formBloqueos = document.querySelector('#tabla-bloqueos-wrapper form');
    // formBloqueos.requestSubmit();
    document.getElementById('boton_guardar_bloqueos').click();
  });
}
</script>

<template>
  <div>
    <input type="hidden" name="tipo_bloqueo" :value="tipoBloqueo" />
    <ModalBloquearEvaluacion
      v-model="mostrarModal" 
      @aceptar="bloqueoAceptado"
    />
  </div>
</template>
